var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBcRightArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 23 23",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.25612 6.31536C8.89814 6.67334 8.89814 7.25374 9.25612 7.61172L13.1913 11.5469L9.25612 15.482C8.89814 15.84 8.89814 16.4204 9.25612 16.7784C9.6141 17.1364 10.1945 17.1364 10.5525 16.7784L15.1358 12.1951C15.4938 11.8371 15.4938 11.2567 15.1358 10.8987L10.5525 6.31536C10.1945 5.95738 9.6141 5.95738 9.25612 6.31536Z",
    fill: "#23235F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBcRightArrow);
export default __webpack_public_path__ + "static/media/BCRightArrow.5adf8e6884d6bec72fe24fc576b051e6.svg";
export { ForwardRef as ReactComponent };